import { ProductType as CourseType } from "@/common/course/types";
import type { Category } from "@/components/ProductCardListWrapper/variants/ProductCardListBySearchTab/types";

/**
 * Same sequence as category sort: normalize `orderKeys`, optionally
 * put `"course"` first, then `sort` by `indexOf` with the same logic for -1.
 */
function reorderItemsByKeyOrder<T>(
  items: T[],
  orderKeys: readonly string[],
  prioritizeCoursesFirst: boolean,
  getComparableKey: (item: T) => string,
): T[] {
  let keys = orderKeys.map((x) => x.toLowerCase().replace(/\s+/g, ""));
  const courseKeyIndex = keys.findIndex((k) => k.toLowerCase() === "courses");

  if (prioritizeCoursesFirst) {
    if (courseKeyIndex !== -1) {
      keys.splice(courseKeyIndex, 1);
    }
    keys = ["courses", ...keys];
  }

  return items
    .map((item, index) => ({ item, index }))
    .sort((a, b) => {
      const keyA = getComparableKey(a.item).toLowerCase().replace(/\s+/g, "");
      const keyB = getComparableKey(b.item).toLowerCase().replace(/\s+/g, "");

      const aIndex = keys.indexOf(keyA);
      const bIndex = keys.indexOf(keyB);

      if (aIndex === -1 && bIndex === -1) {
        return a.index - b.index;
      }

      if (aIndex === -1) return 1;
      if (bIndex === -1) return -1;

      return aIndex - bIndex;
    })
    .map(({ item }) => item);
}

export function getFilteredTrendingCategories(
  categories: Category[] | undefined,
  categoryKeyOrder: readonly string[],
  prioritizeCoursesFirst: boolean,
): Category[] {
  const withoutBootcamps =
    categories?.filter((category) => {
      return category.productType !== CourseType.BOOTCAMP;
    }) ?? [];

  const sortedCategories = reorderItemsByKeyOrder(
    withoutBootcamps,
    categoryKeyOrder,
    prioritizeCoursesFirst,
    (c) => c.categoryKey,
  );

  return sortedCategories;
}
